import { gambits } from '@/core/gambits';
import { AppEndpoint } from '@/core/network/api/constants/api.url.constant';

export function getBlobImage(hash: string, width = 128) {
  let url = `${gambits.configService.getServiceRoutingHost()}${AppEndpoint.BLOB}`;
  url = url.replace(new RegExp('{blobHash}', 'g'), hash || '');

  return `${url}?width=${width}`;
}
